import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import CandidateRoutes from "./routes/CandidateRoutes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CandidateRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0c0c16",
            border: "1px solid #3d414f",
            color: "#ffffff",
          },
        }}
      />
    </div>
  );
}

export default App;
